import React from 'react';
import { Tooltip, Typography } from '@mui/material';

interface CustomTooltipProps {
    text: string;
    previewLength?: number;
    fullText: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ text, fullText, previewLength = 20 }) => {
    const previewText = text.length > previewLength ? text.substring(0, previewLength) + '...' : text;

    return (
        <Tooltip title={<Typography variant="body2">{fullText}</Typography>} arrow>
            <Typography variant="body2" noWrap>
                {previewText}
            </Typography>
        </Tooltip>
    );
};

export default CustomTooltip; 